import createDataAccessStore from './BaseDataAccessStore';
/**
 *
 * @param modelType
 * @param graphQlService
 * @param detailDescription
 * @param queryDescription
 * @param defaultQueryParameters The default query parameters will be used when you call just query()
 * For all other queries, don't create an action which excepts query parameters, whenever possible!
 */
var createGraphQlDataAccessStore = function (modelType, graphQlService, dtoMapper, defaultQueryParameters) {
    return createDataAccessStore(modelType, graphQlService, dtoMapper, defaultQueryParameters);
};
export default createGraphQlDataAccessStore;
//# sourceMappingURL=BaseGraphQlDataAccessStore.js.map